module.exports = __webpack_public_path__ + "static/img/59saas.c0345184.png";